import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { baseUrl } from '../../api/common';
import axios from 'axios';
import Loader from '../common/Loader';
import MembershipCertificate from './certificate/membership-certificate-web';
import FMASCertificate from './certificate/fmas-certificate-web'; // Assuming this component exists
import { convertCertificateDate } from './common';
import Header from './Header';
import Footer from './Footer';
import { decryptSlug } from '../../util/encryption'; 

const UserMembershipApplicationCertificate = () => {
  const { slug } = useParams();
  const decryptedId = decryptSlug(slug); 
  const [memberDetails, setMemberDetails] = useState({});
  const [certificateDetails, setCertificateDetails] = useState({});
  const [fmasDetails, setFMASDetails] = useState({});
  const [activeTab, setActiveTab] = useState('membership'); // State for active tab

  const fetchMemberDetailsData = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_detail`,
        { id: decryptedId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );
      if (response.data.status) {
        setMemberDetails(response.data.data[0]);
        setFMASDetails(response.data.fmas_data[0]);
        fetchMembershipCertificate(response.data.data[0].member_reg_date);
        console.log(response.data, 'fetchMemberDetailsData');
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

  const fetchMembershipCertificate = async applicationDate => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/certificate_data_list`,
        { member_apply_date: applicationDate },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );
      if (response.data.status) {
        setCertificateDetails(response.data.data[0]);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

  useEffect(() => {
    fetchMemberDetailsData();
  }, [decryptedId]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === 'fmas') {
      // Add logic to fetch FMAS certificate data if needed
    } else {
      fetchMembershipCertificate(memberDetails.member_reg_date);
    }
  };

  const certificateProps = {
    certificateDetails,
    firstName: memberDetails.first_name,
    middleName: memberDetails.middle_name,
    lastName: memberDetails.last_name,
    applicationName: memberDetails.application_name,
    membershipNumber: memberDetails.membership_no,
    membershipDate: convertCertificateDate(memberDetails.member_reg_date),
  };

  const hasCertificateData = memberDetails && certificateDetails && memberDetails.membership_no;

  return (
    <section className="user_div_total">
      <Header />
      <div className='container pt-50 pb-50'>
        <div className='row'>
          <div className='col-md-12'>
            <div className="view_total_page">
              <div className="row user_application_div_clr user_tab align-items-center">
                {hasCertificateData && (
                  <div className="col-md-6 col-12">
                    <div className="tracking_head">
                      <h2>My Certificates</h2>
                    </div>
                  </div>
                )}
                {hasCertificateData && (
                  <div className="col-md-6 col-12">
                    <div className="tracking_head">
                      <ul className="nav nav-tabs certificate-tabs" role="tablist">
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${activeTab === 'membership' ? 'active' : ''}`}
                            onClick={() => handleTabChange('membership')}
                            role="tab"
                            aria-selected={activeTab === 'membership'}
                          >
                            Membership Certificate
                          </button>
                        </li>
                        {fmasDetails&&fmasDetails.certificate_file &&
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${activeTab === 'fmas' ? 'active' : ''}`}
                            onClick={() => handleTabChange('fmas')}
                            role="tab"
                            aria-selected={activeTab === 'fmas'}
                          >
                            FMAS Certificate
                          </button>
                        </li>}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <div className="certificate-scroll-container">
                <div className="certificate-content">
                  {hasCertificateData ? (
                    activeTab === 'membership' ? (
                      <MembershipCertificate {...certificateProps} />
                    ) : (
                      <FMASCertificate
                        certificate={`${baseUrl}/${fmasDetails.certificate_file}`}
                        firstName={memberDetails.first_name}
                        middleName={memberDetails.middle_name}
                        lastName={memberDetails.last_name}
                        applicationName={memberDetails.application_name}
                        membershipNumber={memberDetails.membership_no}
                        membershipDate={convertCertificateDate(memberDetails.member_reg_date)}
                      />
                    )
                  ) : (
                    <div className="col-md-6 col-12">
                      <div className="tracking_head">
                        <h4>No Certificate Available</h4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <style jsx>{`
        .certificate-tabs {
          display: flex;
          overflow-x: auto;
          white-space: nowrap;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE and Edge */
          padding-bottom: 5px;
          border-bottom: 1px solid #dee2e6;
        }
        .certificate-tabs::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
        .certificate-tabs .nav-item {
          flex: 0 0 auto;
        }
        .certificate-tabs .nav-link {
          padding: 8px 16px;
          font-size: 14px;
          color: #495057;
          background: none;
          border: none;
          border-bottom: 2px solid transparent;
          transition: all 0.3s ease;
        }
        .certificate-tabs .nav-link:hover {
          color: #007bff;
          border-bottom: 2px solid #007bff;
        }
        .certificate-tabs .nav-link.active {
          color: #007bff;
          border-bottom: 2px solid #007bff;
          font-weight: 600;
        }
        .certificate-scroll-container {
          overflow-x: auto;
          padding: 10px 0;
          scrollbar-width: thin;
          -webkit-overflow-scrolling: touch;
        }
        .certificate-content {
          display: inline-block;
          min-width: 100%;
        }
        .certificate-scroll-container::-webkit-scrollbar {
          height: 6px;
        }
        .certificate-scroll-container::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 3px;
        }
        .certificate-scroll-container::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 3px;
        }
        .certificate-scroll-container::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        @media (max-width: 768px) {
          .certificate-tabs {
            padding: 0 10px;
            margin-bottom: 10px;
          }
          .certificate-tabs .nav-link {
            font-size: 12px;
            padding: 6px 12px;
          }
          .certificate-scroll-container {
            padding: 5px 10px;
          }
          .tracking_head h2 {
            font-size: 20px;
          }
          .tracking_head h4 {
            font-size: 16px;
          }
        }
        @media (max-width: 576px) {
          .user_tab {
            flex-direction: column;
            align-items: flex-start;
          }
          .col-md-6 {
            width: 100%;
            margin-bottom: 10px;
          }
          .certificate-tabs {
            width: 100%;
            justify-content: flex-start;
          }
        }
      `}</style>
    </section>
  );
};

export default UserMembershipApplicationCertificate;


// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { baseUrl } from '../../api/common';
// import axios from 'axios';
// import Loader from '../common/Loader';
// import MembershipCertificate from './certificate/membership-certificate-web';
// import { convertCertificateDate } from './common';
// import Header from './Header';
// import Footer from './Footer';
// import { decryptSlug } from '../../util/encryption'; 

// const UserMembershipApplicationCertificate = () => {
//   const { slug } = useParams();
//   const decryptedId = decryptSlug(slug); 
//   const [memberDetails, setMemberDetails] = useState({});

//   const fetchMemberDetailsData = async () => {
//     try {
//       const response = await axios.post(
//         `${baseUrl}/api/member_detail`,
//         { id: decryptedId },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: localStorage.getItem('access_token'),
//           },
//         }
//       );
//       if (response.data.status) {
//         setMemberDetails(response.data.data[0]);
//         fetchMembershipCertificate(response.data.data[0].member_reg_date);
//         console.log(response.data, 'fetchMemberDetailsData');
//       } else {
//         console.error('Error: Failed to fetch user data');
//       }
//     } catch (error) {
//       console.error('Error fetching users data:', error);
//     }
//   };
//   const [certificateDetails, setCertificateDetails] = useState({});
//   const fetchMembershipCertificate = async applicationDate => {
//     try {
//       const response = await axios.post(
//         `${baseUrl}/api/certificate_data_list`,
//         { member_apply_date: applicationDate },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: localStorage.getItem('access_token'),
//           },
//         }
//       );
//       if (response.data.status) {
//         setCertificateDetails(response.data.data[0]);
//       } else {
//         console.error('Error: Failed to fetch user data');
//       }
//     } catch (error) {
//       console.error('Error fetching users data:', error);
//     }
//   };
//   useEffect(
//     () => {
//       fetchMemberDetailsData();
//     },
//     [decryptedId]
//   );

//   return (
//     <section className="user_div_total">
//       <Header />
//       <div className='container pt-50 pb-50'>
//         <div className='row'>
//           <div className='col-md-12'>
//             <div className="view_total_page">
//               <div className="row user_application_div_clr user_tab">
//                 <div className="col-md-6">
//                   <div className="tracking_head">
//                     <h2>Membership Certificate</h2>
//                   </div>
//                 </div>
//                 <div className="col-md-6">
//                   <div className="tracking_head">

//                   </div>
//                 </div>
//               </div>
//               {/* {memberDetails && certificateDetails && memberDetails.membership_no  
//           ?  */}
//               <MembershipCertificate
//                 certificateDetails={certificateDetails}
//                 firstName={memberDetails.first_name}
//                 middleName={memberDetails.middle_name}
//                 lastName={memberDetails.last_name}
//                 applicationName={memberDetails.application_name}
//                 membershipNumber={memberDetails.membership_no}
//                 membershipDate={convertCertificateDate(
//                   memberDetails.member_reg_date
//                 )}
//               />
//               {/*  : <div className="col-md-6">
//              <div className="tracking_head">
//                <h4>No Membership Certificate Available</h4>
//             </div>
//            </div>  } */}
//             </div>
//           </div>
//         </div>
//       </div>

//       <Footer />
//     </section>
//   );
// };
// export default UserMembershipApplicationCertificate;
